import { z } from 'zod';
import { OffsetPaginationParamsSchema } from '../offset-pagination.js';
/** Warnings only. A bad PESEL still saves the card (email 2026-09-24, variant B). */
export const PESEL_WARNINGS = {
    INCOMPLETE: 'incomplete',
    TOO_LONG: 'too_long',
    CHECKSUM: 'checksum',
    UNREADABLE_DATE: 'unreadable_date',
    BIRTH_DATE_DIFFERS: 'birth_date_differs',
};
export const PeselWarningSchema = z.enum(Object.values(PESEL_WARNINGS));
export const PeselAssessmentSchema = z.object({
    digitsLeft: z.number().int().nullable(),
    birthDateFromPesel: z.iso.date().nullable(),
    warnings: z.array(PeselWarningSchema),
});
export const PatientDtoSchema = z.object({
    id: z.number().int().positive(),
    tenantId: z.number().int().positive(),
    firstName: z.string().min(1).max(255),
    lastName: z.string().min(1).max(255),
    birthDate: z.iso.date().nullable(),
    pesel: z.string().max(32).nullable(),
    sex: z.string().max(50).nullable(),
    address: z.string().nullable(),
    admissionBookNumber: z.string().max(64).nullable(),
    notes: z.string().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const RegisterPatientRequestSchema = z.object({
    firstName: z.string().trim().min(1).max(255),
    lastName: z.string().trim().min(1).max(255),
    birthDate: z.iso.date().nullable().optional(),
    pesel: z.string().max(32).nullable().optional(),
    sex: z.string().max(50).nullable().optional(),
    address: z.string().nullable().optional(),
    admissionBookNumber: z.string().max(64).nullable().optional(),
    notes: z.string().nullable().optional(),
});
export const RegisterPatientResponseSchema = z.object({
    patient: PatientDtoSchema,
    pesel: PeselAssessmentSchema,
});
export const PatientListSortSchema = z.enum(['lastName', 'firstName', 'admissionBookNumber']);
export const PatientListOrderSchema = z.enum(['asc', 'desc']);
export const PatientListQuerySchema = OffsetPaginationParamsSchema.extend({
    search: z.string().trim().max(100).optional(),
    sort: PatientListSortSchema.optional(),
    order: PatientListOrderSchema.optional(),
});
//# sourceMappingURL=patients.schema.js.map